export default "__VITE_ASSET__m5NmOwmK__"